export const mainDiv = {
    height : '100vh',
    width : '100%',
    display: 'flex',
    justifyContent: 'center',
};